import { API } from '@vcd-ecm-ui/Common';
import {
  createStore, applyMiddleware, compose,
} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import { GATEWAY_ENDPOINT } from '../constants/constants';

const api = new API(GATEWAY_ENDPOINT);

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancer = composeEnhancers(
  applyMiddleware(thunk.withExtraArgument(api)),
);

const store = createStore(
  rootReducer,
  enhancer,
);

export default store;
